const stripPemMarkers = (value: string): string =>
  value
    .replace(/-----BEGIN [^-]+-----/g, "")
    .replace(/-----END [^-]+-----/g, "")
    .replace(/\s+/g, "")
    .trim();

/**
 * Returns base64-only public key from API response payload.
 */
export const getSanitizedPublicKeyFromResponse = (value: any): string => {
  const candidate = value

  if (typeof candidate !== "string") return "";
  return stripPemMarkers(candidate);
};

